/**
 * ファイル名に使用できない文字を除去・正規化する
 * - 前後の空白をトリム
 * - OS/ブラウザで問題になる文字（/ \ : * ? " < > |）をアンダースコアに置換
 * - 結果が空の場合はフォールバック値を返す
 */
export const sanitizeFilename = (name: string, fallback = 'master'): string => {
  const sanitized = name
    .trim()
    .replace(/[/\\:*?"<>|]/g, '_')
    .replace(/\s+/g, ' ')

  return sanitized || fallback
}
